import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconItalic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconItalic"><Path fillRule="evenodd" clipRule="evenodd" d="M9 3H20V5H15.2352L10.8602 19H15V21H4V19H8.76481L13.1398 5H9V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconItalic;
